import React from 'react';
import './contact.css';

export default function Contact() {
  return (
    <section className="contact-section">
      <div className="contact-container">
        <h1>Contact Us</h1>
        <p>We’d love to hear from you! Reach out to us through the following platforms:</p>
        <ul className="contact-list">
          <li>
            <a 
              href="https://www.instagram.com/prasanna_kumar_simmhadri_2005/?hl=en" 
              target="_blank" 
              rel="noopener noreferrer" 
              aria-label="Visit our Instagram profile">
              <ion-icon name="logo-instagram"></ion-icon> Instagram
            </a>
          </li>
          <li>
            <a 
              href="https://www.facebook.com/profile.php?id=100083873681403" 
              target="_blank" 
              rel="noopener noreferrer" 
              aria-label="Visit our Facebook page">
              <ion-icon name="logo-facebook"></ion-icon> Facebook
            </a>
          </li>
          <li>
            <a 
              href="https://x.com/Prasannak5002" 
              target="_blank" 
              rel="noopener noreferrer" 
              aria-label="Visit our Twitter profile">
              <ion-icon name="logo-twitter"></ion-icon> Twitter
            </a>
          </li>
          <li>
            <a 
              href="mailto:prasannasimha5002@gmail.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              aria-label="Send us an email">
             <ion-icon name="mail-outline"></ion-icon> Mail Us
            </a>
          </li>
          <li>
          <a  target="_blank" 
              rel="noopener noreferrer" 
             href='https://wa.me/8309179509
'><ion-icon name="logo-whatsapp"></ion-icon>whatsapp</a>
          </li>
        </ul>
      </div>
    </section>
  );
}
